import React from 'react';
import './Informational.css';

const Informational = () => {
  return (
    <section className="informational">
      <div className="hero-background">
        <div className="hero-content">
          <h2>
As Criptomoedas, em 2025, são uma pauta
de interesse público.</h2>
          <p>
          A última eleição presidencial americana foi
decisivamente influenciada pelo cripto-
eleitorado. Os Estados Unidos agora
discutem a criação de uma reserva nacional
de Bitcoin
          </p>
          <p>Uma proposta na mesma linha já foi flutuada
no Congresso brasileiro – assim como em
outras onze democracias.
</p>
<p>O Brasil tem um dos 10 maiores mercados
consumidores de cripto do planeta, mas, até
hoje, há pouca informação bruta sobre.
A maioria dos indicadores de posse e
conhecimento de cripto no nosso país vem
de estimativas estrangeiras, ou fontes
secundárias.</p>
          <p className="instruction">PASSE O MOUSE SOBRE OS PONTOS</p>
        </div>
      </div>
    </section>
  );
};

export default Informational;
